<template>
  <v-window
    v-model="config.page">
    <v-window-item value="summary">
      <v-row dense>
        <v-col cols="12">
          <span class="font-weight-bold">送金日: </span>
          <MarkTag :text="getContent.date" :match="getQuery" />
        </v-col>
        <v-col cols="12">
          <v-list dense>
            <v-list-item v-for="item in getContent.items" :key="item.id">
              <v-list-item-content>
                <v-list-item-subtitle>
                  <v-row dense>
                    <v-col cols="6">
                      <MarkTag :text="item.item" :match="getQuery" />
                    </v-col>
                    <v-col cols="6" class="text-right">
                      <MarkTag :text="`${item.currency}${item.sum} x @${item.rate}`" :match="getQuery" />
                    </v-col>
                  </v-row>
                </v-list-item-subtitle>
                <v-list-item-title>
                  <MarkTag :text="item.yen" :match="getQuery" />
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold">
                <MarkTag :text="`小計：${getContent.total}円`" :match="getQuery" />
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn text
                  color="secondary"
                  :disabled="!hasParentId"
                  :loading="isLoading"
                  @click="mvDetails"><v-icon small class="mr-2">fal fa-angle-right</v-icon>詳細を開く</v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-col>
        <v-col cols="12" v-if="getContent.note">
          <span class="font-weight-bold">備考欄: </span>
          <MarkTag :text="getContent.note" :match="getQuery" />
        </v-col>
      </v-row>
    </v-window-item>
    <v-window-item value="details">
      <v-row dense>
        <v-col cols="12">
          <span class="font-weight-bold">送金日: </span>
          <MarkTag :text="getParentDate" :match="getQuery" />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12">
          <v-list dense>
            <template v-for="group in getParentGroupItems">
              <v-list-item v-for="item in group.children" :key="item.id">
                <v-list-item-content>
                  <v-list-item-subtitle>
                    <v-row dense>
                      <v-col cols="6">
                        <MarkTag :text="item.item" :match="getQuery" />
                      </v-col>
                      <v-col cols="6" class="text-right">
                        <MarkTag :text="`${item.currency}${item.sum} x @${item.rate}`" :match="getQuery" />
                      </v-col>
                    </v-row>
                  </v-list-item-subtitle>
                  <v-list-item-title>
                    <MarkTag :text="`${item.client ? `${item.client}：` : ''}${item.yen}円`" :match="getQuery" />
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-divider :key="`${group.id}_div`"></v-divider>
              <v-list-item :key="`${group.id}_sub`" class="grey lighten-4">
                <v-list-item-content>
                  <v-list-item-title class="font-weight-bold">
                    <MarkTag :text="`小計：${group.subtotal}円`" :match="getQuery" />
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </template>
            <v-list-item>
              <v-list-item-content>
                <v-list-item-title class="font-weight-bold">
                  <MarkTag :text="`総計：${getParentItemsTotal}円`" :match="getQuery" />
                </v-list-item-title>
              </v-list-item-content>
              <v-list-item-action>
                <v-btn text
                  color="secondary"
                  @click="mvSummary"><v-icon small class="mr-2">fal fa-angle-left</v-icon>詳細を閉じる</v-btn>
              </v-list-item-action>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </v-window-item>
  </v-window>
</template>

<script>
import MarkTag from '@/components/tags/mark'
export default {
  name: 'postTransferLayout',
  props: [ 'status', 'item', 'parent' ],
  data () {
    return {
      config: {
        page: 'summary'
      }
    }
  },
  components: {
    MarkTag
  },
  methods: {
    mvDetails: function (req) {
      const { id } = this.$props.parent || { id: '' }
      const { gid } = this.$props.item || { content: '' }
      if (id) {
        this.$set(this.config, 'page', 'details')
      } else if (gid) {
        this.$emit('emit', {
          action: 'submit',
          data: { type: 'detail' }
        })
      }
    },
    mvSummary: function () {
      this.$set(this.config, 'page', 'summary')
    }
  },
  computed: {
    hasParentId () {
      return this.$props.item && this.$props.item.gid
    },
    isLoading () {
      return this.$props.status && this.$props.status.loading
    },
    getQuery () {
      return this.$route.query && this.$route.query.query || ''
    },
    getContent () {
      const content = (this.$props.item && this.$props.item.content) ? Object.assign(JSON.parse(this.$props.item.content), {
        date: this.$props.item.date ? this.$moment(this.$props.item.date).format('YYYY年MM月DD日') : ''
      }) : {
        date: '',
        items: [],
        note: ''
      }
      return Object.assign(content, {
        items: content.items && content.items.length ? content.items.map(it => {
          const { item, currency, sum, rate, floor } = it
          const yen = floor ? Math.floor(sum * rate) : Math.ceil(sum * rate)
          return {
            id: this.$uuid(),
            item,
            currency,
            sum: `${sum}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'),
            rate,
            yen: `${`${yen}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}円`
          }
        }) : [],
        total: `${content.items && content.items.length ? content.items.reduce((prev, it) => {
          const { sum, rate, floor } = { sum: parseFloat(it.sum), rate: parseFloat(it.rate), floor: it.floor }
          const current = floor ? Math.floor(sum * rate) : Math.ceil(sum * rate)
          return prev + current
        }, 0) : 0}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'),
        gid: content.gid || ''
      })
    },
    getParentDate () {
      const { date } = this.$props.parent || { date: '' }
      return date ? this.$moment(date).format('YYYY年MM月DD日') : ''
    },
    getParentGroupItems () {
      const { items } = this.$props.parent || { items: [] }
      const subs = {}
      if (items) {
        for (const it of items) {
          const { sum, rate, inc, floor, client } = { client: it.client, sum: parseFloat(it.sum.replace(',', '')), rate: parseFloat(it.rate), inc: it.inc, floor: it.floor }
          if (!subs[inc]) {
            subs[inc] = {
              children: [],
              subtotal: 0
            }
          }
          const yen = floor ? Math.floor(sum * rate) : Math.ceil(sum * rate)
          subs[inc].children.push(Object.assign({}, it, {
            id: this.$uuid(),
            sum: `${sum}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,'),
            client: client.name ? client.name.replace(',', ' ') : '',
            yen: `${yen}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          }))
          subs[inc].subtotal += yen
        }
        const keys = Object.keys(subs)
        return keys.length ? keys.map(key => {
          return {
            id: this.$uuid(),
            key,
            children: subs[key].children,
            subtotal: `${subs[key].subtotal}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
          }
        }) : []
      } else {
        return []
      }
    },
    getParentItemsTotal () {
      const { items } = this.$props.parent || { items: [] }
      const total = items && items.length ? items.reduce((prev, it) => {
        const { sum, rate, floor } = { sum: parseFloat(it.sum.replace(',', '')), rate: parseFloat(it.rate), floor: it.floor }
        const current = floor ? Math.floor(sum * rate) : Math.ceil(sum * rate)
        return prev + current
      }, 0) : 0
      return `${total}`.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
    }
  }
}
</script>